import type { MarketSpecificContent } from './types';

export const getContentForMarket = <TContent>(
  host: string,
  content: MarketSpecificContent<TContent>[]
) => content.find((c) => c.host === host);
